import { connect } from 'react-redux'
import TeachersFilter from './teachers-filter'
import {
  getFilterStatus,
  getFilterSearch
} from '../../../../stores/teachers-filter/teachers-filter.selectors'
import {
  setStatusFilter,
  setSearchValue
} from '../../../../stores/teachers-filter/teachers-filter.actions.js'

const mapStateToProps = state => ({
  searchValue: getFilterSearch(state),
  statusFilter: getFilterStatus(state)
})

const mapDispatchToProps = dispatch => ({
  onFilter: status => dispatch(setStatusFilter(status)),
  onSearchChange: e => dispatch(setSearchValue(e.target.value))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeachersFilter)
